import { isRSAA, RSAA } from 'redux-api-middleware';

/**
 * Unique identifier used to match up www requests with api requests.
 */
let correlationId = null;

/**
 * Redux middleware to log web requests
 */
const logger = () => next => action => {
  // On every page load or route change we want to generate a new unique correlation ID
  // and track an event with that new id. Also track the page view.
  // refactoring here as method signature asks for key value pair as all arguments
  correlationId = window.appInsights?.context?.getSessionId();
  if (['LOGIN', '@@router/LOCATION_CHANGE'].includes(action.type)) {
    if (window.appInsights) {
      // TODO - Send the current page and url
      window.appInsights.trackPageView();
    }
  }

  // Intercepting all api calls here to add the correlation ID as a header
  if (isRSAA(action) && correlationId) {
    // eslint-disable-next-line no-param-reassign
    action[RSAA].headers = {
      ...action[RSAA].headers,
      'correlation-id': correlationId,
    };
  }

  return next(action);
};

export default logger;
